export const deClientPortalAssetKeyValues = {
    basedOn: 'Kennzahlen basieren auf {{source}} vom {{date}}',
    basedOnSources: {
        draft: 'dem Entwurf',
        importedDraft: 'dem importierten Entwurf',
        valuation: 'der Bewertung',
        importedValuation: 'der importierten Bewertung',
    },
    marketValueDevelopmentTitle: 'Entwicklung Marktwert',
    rentAndCostsDevelopmentTitle: 'Entwicklung Miete und Kosten',
    chart: {
        yearFilterUnitLabel: 'J',
    },
    chartSeries: {
        managementCosts: 'Bewirtschaftungskosten',
        maintenanceCosts: 'Instandhaltungskosten',
        administrativeCosts: 'Verwaltungskosten',
        lossOfRentRisk: 'Mietausfallwagnis',
    },
    assetLocation: {},
    energyEfficiency: {},
    noValuationInfo: {
        description: 'Für diese Immobilie liegen noch keine Daten aus abgeschlossenen Bewertungen vor.',
        viewOrder: 'Auftrag einsehen',
        createOrder: 'Neuen Auftrag erstellen',
    },
    allValues: {
        sections: {
            mortgageLendingValueResults: 'Beleihungswertergebnisse',
            yields: 'Rendite',
            relevantArea: 'Bewertungsrelevante Fläche',
        },
        year: 'Jahr',
        years: 'Jahre',
    },
}
